import { Button, FormGroup, Label, Modal, Textarea } from "@xola/ui-kit";
import React, { useState } from "react";
import { Except } from "type-fest";
import { Attachment } from "types";
import { FileUploadInput } from "../../Common/FileUploadInput";
import { NoTranslate } from "../../Common/NoTranslate";
import { SecondaryButton } from "../../Common/SecondaryButton";

interface AttachmentModifyModalProps {
    isOpen: boolean;
    file: Attachment;
    onFileModify: (payload: Attachment, file: Attachment) => void;
    onInstructionChange: (attachment: Attachment, instruction: string) => void;
    isLoading: boolean;
    onClose: () => void;
}

export const AttachmentModifyModal = (props: AttachmentModifyModalProps) => {
    return (
        <Modal isOpen={props.isOpen} onClose={props.onClose}>
            <ModalContent {...props} />
        </Modal>
    );
};

const ModalContent = ({
    onFileModify,
    onInstructionChange,
    file,
    isLoading,
    onClose,
}: Except<AttachmentModifyModalProps, "isOpen">) => {
    const [instruction, setInstruction] = useState(file.caption ?? "");
    const [attachment, setAttachment] = useState(file);
    const [isError, setIsError] = useState(!file.caption);

    const handleFileChange = (file: Attachment) => {
        const payload = {
            ...attachment,
            title: file.name,
            size: file.size,
            name: file.name,
        };
        setAttachment(payload);
        onFileModify(payload, file);
    };

    const handleTextChange = (e: any) => {
        setInstruction(e.target.value);
    };

    const handleClick = () => {
        if (instruction.trim()) {
            onInstructionChange(attachment, instruction);
        }
    };

    return (
        <>
            <Modal.Header>Modify Attachment</Modal.Header>
            <Modal.Body>
                <div className="mb-2 flex items-center space-x-2">
                    <span>Filename : </span>
                    <NoTranslate>{attachment.title}</NoTranslate>
                    <FileUploadInput buttonLabel="Replace" isLoading={isLoading} onChange={handleFileChange} />
                </div>

                <FormGroup>
                    {isError && <Label className="!text-danger">Instruction is required</Label>}
                    <Textarea
                        isRequired
                        value={instruction}
                        row={3}
                        isError={isError}
                        onKeyUp={(e: any) => setIsError(!e.target.value)}
                        onChange={handleTextChange}
                    />
                </FormGroup>
            </Modal.Body>
            <Modal.Footer className="flex justify-end">
                <SecondaryButton onClick={onClose}>Close</SecondaryButton>
                <Button color="primary" onClick={handleClick}>
                    Save
                </Button>
            </Modal.Footer>
        </>
    );
};
